const LOAD_HQ_CHAPTERS = 'LOAD_HQ_CHAPTERS';

export default { LOAD_HQ_CHAPTERS };
